import { MHTTPCL, JSON_STRING, HttpClient } from "../../../services/http/http-client";
import {HttpLib} from "../../../services/http/http-lib"
import { SETTINGS_URL } from "../../../services/common-urls";

export const SharingSettingsService = {
  findSharingData: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'sharing',
  
    output: JSON_STRING,
  }),
    
  getRssData:(artist_id)=>MHTTPCL.get(SETTINGS_URL,{
    section:'sharing',
    action: 'create_rss',
    artist_id:artist_id
  }),

  getRssJson:(url)=>HttpLib.get(url)


}

